/** Queue names and job payloads shared by the API and the two workers. */
import { z } from 'zod';
export const QUEUE_GENERATION = 'generation';
export const QUEUE_BUILD = 'build';
export const QUEUE_NAMES = [QUEUE_GENERATION, QUEUE_BUILD];
export const generationTypeSchema = z.enum(['create', 'edit', 'repair']);
/**
 * Every job carries the ids needed to settle credits without a second lookup, and
 * an idempotency key, because BullMQ redelivers on worker death and the ledger is
 * append-only.
 */
export const generationJobSchema = z.object({
    generationId: z.uuid(),
    projectId: z.uuid(),
    userId: z.uuid(),
    type: generationTypeSchema,
    prompt: z.string().min(1).max(8_000),
    /** Version the edit is based on. Null for the first generation of a project. */
    parentVersionId: z.uuid().nullable(),
    /**
     * The `data-gen-id` the user clicked, when the edit came from the preview.
     *
     * Passed through to the targeting pass, which resolves it back to a file and a
     * section rather than making the model infer which of six sections was meant.
     */
    targetGenId: z.string().max(120).nullable().default(null),
    /**
     * Zero is a legitimate cost, not a malformed payload.
     *
     * The first EDITS_INCLUDED_PER_GENERATION edits of a site cost nothing —
     * that is the pack model's own selling point — and repairs are always free.
     * `.positive()` here rejected every one of those jobs as invalid before any
     * work began, which shipped a product whose headline feature failed 100% of
     * the time. Negative stays impossible.
     */
    creditsReserved: z.int().nonnegative(),
    idempotencyKey: z.string().min(8).max(128),
});
export const buildJobSchema = z.object({
    generationId: z.uuid(),
    projectId: z.uuid(),
    versionId: z.uuid(),
    userId: z.uuid(),
    /** Object key of the source snapshot the build worker should materialise. */
    sourceKey: z.string().min(1),
    idempotencyKey: z.string().min(8).max(128),
});
/**
 * Defaults applied to every job. Retries are deliberately low: a failed
 * generation refunds credits, and burning three LLM calls on a prompt that the
 * model cannot satisfy costs real money for no better outcome.
 */
export const DEFAULT_JOB_OPTIONS = {
    attempts: 2,
    backoff: { type: 'exponential', delay: 2_000 },
    removeOnComplete: { age: 3_600, count: 1_000 },
    removeOnFail: { age: 86_400 },
};
//# sourceMappingURL=queues.js.map